import { theme as antTheme, ThemeConfig } from 'antd'

export const useTheme = () => {
  const { useToken } = antTheme
  const { token } = useToken()

  const theme: ThemeConfig = {
    token: {
      colorPrimary: '#ff0000',
      colorLink: '#ff0000'
    },
    components: {
      Card: {
        actionsLiMargin: '12px 24px'
      },

      Segmented: {
        trackBg: token.colorBorder
      }
    }
  }

  return theme
}
